// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5003c59d","644":"aa6e249f"}[chunkId] + ".chunk.js";
};